export enum CyberEventRequestType {
    None = "None",
    CreateCompromisedSourcingCompany = "CreateCompromisedSourcingCompany",
    CloseCompromisedSourcingCompany = "CloseCompromisedSourcingCompany",
}